<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Configurer la présentation</p>
        </header>
        <section class="modal-card-body">
            <form method="POST">
                <!-- Draft field -->
                <b-field>
                    <b-switch v-model="showAllMedias" type="is-success">
                        Afficher tous les médias dans la présentation
                    </b-switch>
                </b-field>
            </form>
        </section>
        <footer class="modal-card-foot">
            <div class="field">
                <div class="control">
                    <button class="button is-primary" @click="submit()">
                        <span>Enregistrer les modifications</span>
                    </button>
                    <button class="button" type="button" @click="$parent.close()">Annuler</button>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>

    export default {

        props: ['settings'],

        data() {
            return {
                showAllMedias: null,
            }
        },
    
        methods: {
            submit() {
                Bus.$emit('updateSettings', {
                    showAllMedias: this.showAllMedias
                });
                this.$parent.close();
            },
        },

        created () {
            this.showAllMedias = this.settings.showAllMedias;
        }
    }
</script>